
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexPveyRADBSWoNkygCPnHOc70zbK84JbmfgmbNuQnzw64Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/index.vue?macro=true";
import { default as _91slug_93Ns39Yq8E5rO_45Bk5c5yrS4mL_452N_45DXr_8kvUysEjugAoMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/[slug].vue?macro=true";
import { default as indexY4duFqRBTpbLMWSx6N1A8pllIfveJD_454_j_keP_45_EDAMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/search/index.vue?macro=true";
import { default as productsvY08gfIdvav9xKUd_45DRbPi290PbI96oz44XMNQPLpIMMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/search/products.vue?macro=true";
import { default as documentsW4kHEEBql10GZ25Br9bqZ3BjcqmSXu5h5FPPDlB3ICEMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/search/documents.vue?macro=true";
import { default as searcht2OuLZM_45ilaDo_sBOfVPWzGU_45gglGVblhsVTLAKO_XUMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/search.vue?macro=true";
import { default as _91slug_93pVHZ9kTHFxwIfxU60sX5p3d80yYG3OKQx1IaZe1vmzIMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/news/[slug].vue?macro=true";
import { default as indexCvmkl8R48cK_456ZfyFceMiRhKYkayc2xh0b0ux5NBAfgMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/catalog/index.vue?macro=true";
import { default as _91slug_93hvFNj2yLApauF3Te0ORTQP5DNHFcoqnp4vqpyvitLN0Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/catalog/[slug].vue?macro=true";
import { default as _91slug_93k1fsRGck4vHii9qMzpvB8h79yTXNYBe6PyBLKfFux_sMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/product/[slug].vue?macro=true";
import { default as indexsewE2seu9UyhbBbquUsoCZZ6k_45SyikyfwtyRUH_vvRkMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/documents/[slug]/index.vue?macro=true";
export default [
  {
    name: "index___ru",
    path: "/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/index.vue")
  },
  {
    name: "slug___ru",
    path: "/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/[slug].vue")
  },
  {
    name: searcht2OuLZM_45ilaDo_sBOfVPWzGU_45gglGVblhsVTLAKO_XUMeta?.name,
    path: "/search",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/search.vue"),
    children: [
  {
    name: "search___ru",
    path: "",
    meta: indexY4duFqRBTpbLMWSx6N1A8pllIfveJD_454_j_keP_45_EDAMeta || {},
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/search/index.vue")
  },
  {
    name: "search-products___ru",
    path: "products",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/search/products.vue")
  },
  {
    name: "search-documents___ru",
    path: "documents",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/search/documents.vue")
  }
]
  },
  {
    name: "news-slug___ru",
    path: "/news/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/news/[slug].vue")
  },
  {
    name: "catalog___ru",
    path: "/catalog",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/catalog/index.vue")
  },
  {
    name: "catalog-slug___ru",
    path: "/catalog/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/catalog/[slug].vue")
  },
  {
    name: "product-slug___ru",
    path: "/product/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/product/[slug].vue")
  },
  {
    name: "documents-slug___ru",
    path: "/documents/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/pages/documents/[slug]/index.vue")
  }
]